export const createRibbonName = (type?: string, name?: string) => ['Ribbon', type, name].filter(Boolean).join(' - ');

export default null;
